import axios from '../api/axios';

// ** CarHouse Subscriptions **

export async function createCarHouseSubscription(carHouseId, body) {
  const response = await axios.post(
    `/carHouses/${carHouseId}/subscriptions`,
    JSON.stringify(body),
    {
      headers: {
        'Content-Type': 'application/json',
      },
    }
  );
  return response.data;
}

export async function getCarHouseSubscriptions(carHouseId, pagination, options) {
  options = options || {};

  const headers = {
    'page': pagination?.page,
    'limit': pagination?.total,
  };

  options['headers'] = headers;

  const response = await axios.get(`/carHouses/${carHouseId}/subscriptions`, options);
  return response.data;
}

export async function updateCarHouseSubscription(carHouseId, subscriptionId, body) {
  const response = await axios.patch(
    `/carHouses/${carHouseId}/subscriptions/${subscriptionId}`,
    JSON.stringify(body),
    {
      headers: {
        'Content-Type': 'application/json',
      },
    }
  );
  return response.data;
}

export async function updateSubscription(subscriptionId, body) {
  const response = await axios.patch(
    `/subscriptions/${subscriptionId}`,
    JSON.stringify(body),
    {
      headers: {
        'Content-Type': 'application/json',
      },
    }
  );
  return response.data;
}

// ** User Subscriptions **

export async function createUserSubscription(userId, body) {
  const response = await axios.post(
    `/users/${userId}/subscriptions`,
    JSON.stringify(body),
    {
      headers: {
        'Content-Type': 'application/json',
      },
    }
  );
  return response.data;
}

export async function getUserSubscriptions(userId, query = {}) {
  const response = await axios.get(`/users/${userId}/subscriptions`, { params: query });
  return response.data;
}

export async function updateUserSubscription(userId, subscriptionId, body) {
  const response = await axios.patch(
    `/users/${userId}/subscriptions/${subscriptionId}`,
    JSON.stringify(body),
    {
      headers: {
        'Content-Type': 'application/json',
      },
    }
  );
  return response.data;
}

export async function cancelSubscription(subscriptionId) {
  const response = await axios.patch(`/subscriptions/${subscriptionId}/cancel`);
  return response.data;
}

// ** Credits **

export async function addCarHouseCredits(carHouseId, body) {
  const response = await axios.post(
    `/carHouses/${carHouseId}/credits`,
    JSON.stringify(body),
    {
      headers: {
        'Content-Type': 'application/json',
      },
    }
  );
  return response.data;
}

export async function addUserCredits(userId, body) {
  const response = await axios.post(
    `/users/${userId}/credits`,
    JSON.stringify(body),
    {
      headers: {
        'Content-Type': 'application/json',
      },
    }
  );
  return response.data;
}

// ** Vehicle Purchase **

export async function purchaseVehicle(userId, vehicleId) {
  const response = await axios.post(
    `/users/${userId}/vehicles/${vehicleId}/purchase`
  );
  return response.data;
}
